import merge from 'lodash/merge'
import objectFilter from '@converdy/utils/object-filter'
import baseStyles from '../Base/Base.styles'
import baseButtonStyles from '../BaseButton/BaseButton.styles'
import { parseResponsiveProperty, breakpointsMedia, breakpointsMediaInversed } from '@converdy/styles'

export default ({
  base,
  spacing,
  spread,
  buttons,
  buttonOne,
  buttonTwo
}) => {
  let jss = {
    root: {
      ...baseStyles(base),
      ...parseResponsiveProperty((c) => ({'--spacing': `${c/2}px` }), spacing),
      display: 'flex'
    }
  }

  jss = merge(jss, {
    root: objectFilter(Boolean)({
      '& .buttonOne': buttons.includes('buttonOne') && baseButtonStyles(buttonOne),
      '& .buttonTwo': buttons.includes('buttonTwo') && baseButtonStyles(buttonTwo),
    })
  })

  if (spread) {
    
        merge(jss.root, {
          ...parseResponsiveProperty((c) => {

            switch(c) {
              case 'fullWidth':
                return {
                '& > .baseButton': {
                    flexGrow: 1,
                    width: '100%'
                  },
                  '& > .baseButton:not(:last-of-type)': {
                    marginRight: 'var(--spacing)'
                  }
                }
                break
            case 'stackedFullWidth':
              return {
                '&': {
                  flexDirection: 'column'
                },
                '& > .baseButton': {
                    width: '100%'
                  },
                '& > .baseButton:not(:last-of-type)': {
                    marginBottom: 'var(--spacing)',
                    marginRight: '0px !important'
                  }
                }
                break
            case 'stacked':
              return {
                '&': {
                  flexDirection: 'column',
                  justifyContent: 'center'
                },
                '& > .baseButton:not(:last-of-type)': {
                  marginBottom: 'var(--spacing)',
                  marginRight: '0px !important'
                }
              }
            break
            case 'basic':
              return {
                '& > .baseButton:not(:last-of-type)': {
                  marginRight: 'var(--spacing)'
                }
              }
            break;
          }
          
        }, spread)

      })
    

  }

  return jss
}
